import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';

import {getTours, onFilterTours, searchPageUnMounted} from './Actions';
import {getTourById} from '../TourPage/Actions';

const stateToProps = (state) => {
  return {
    cities: state.main.cities,
    categories: state.main.tourCategories,
    searchSelectedCity: state.searchResult.searchSelectedCity,
    tours: state.searchResult.tours,
    filterTours: state.searchResult.filterTours,
    othersTours: state.searchResult.othersTours,
    promiseGetTours: state.searchResult.promise.getTours,
  }
};

const dispatchToProps = (dispatch) => {
  return {
    getTours: (cityId, history) => {
      dispatch(getTours(cityId, history))
    },
    getTourById: (id, history) => {
      dispatch(getTourById(id, history))
    },
    onFilterTours: (categoriesId, peoples, date) => {
      dispatch(onFilterTours(categoriesId, peoples, date))
    },
    searchPageUnMounted: () => {
      dispatch(searchPageUnMounted())
    }
  }
};

export default withRouter(connect(stateToProps, dispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/SearchResult/index.js